// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ContentRouteRouteImport } from './routes/_content/route'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as ContentAudienceRouteRouteImport } from './routes/_content/audience/route'
import { Route as ContentBlogRouteRouteImport } from './routes/_content/blog/route'
import { Route as ContentCompareRouteRouteImport } from './routes/_content/compare/route'
import { Route as ContentDocsRouteRouteImport } from './routes/_content/docs/route'
import { Route as ContentFeatureRouteRouteImport } from './routes/_content/feature/route'
import { Route as ContentPricingRouteRouteImport } from './routes/_content/pricing/route'
import { Route as ClaimIndexRouteImport } from './routes/claim/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardIdentitiesRouteRouteImport } from './routes/dashboard/identities/route'
import { Route as DashboardInboxRouteRouteImport } from './routes/dashboard/inbox/route'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as PrivacyIndexRouteImport } from './routes/privacy/index'
import { Route as TermsIndexRouteImport } from './routes/terms/index'
import { Route as ContentAudienceIndexRouteImport } from './routes/_content/audience/index'
import { Route as ContentBlogIndexRouteImport } from './routes/_content/blog/index'
import { Route as ContentCompareIndexRouteImport } from './routes/_content/compare/index'
import { Route as ContentDocsIndexRouteImport } from './routes/_content/docs/index'
import { Route as ContentFeatureIndexRouteImport } from './routes/_content/feature/index'
import { Route as ContentPricingIndexRouteImport } from './routes/_content/pricing/index'
import { Route as DashboardAnalyticsIndexRouteImport } from './routes/dashboard/analytics/index'
import { Route as DashboardApiKeysIndexRouteImport } from './routes/dashboard/api-keys/index'
import { Route as DashboardComposeIndexRouteImport } from './routes/dashboard/compose/index'
import { Route as DashboardConnectedAccountsIndexRouteImport } from './routes/dashboard/connected-accounts/index'
import { Route as DashboardContactsIndexRouteImport } from './routes/dashboard/contacts/index'
import { Route as DashboardIdentitiesIndexRouteImport } from './routes/dashboard/identities/index'
import { Route as DashboardInboxIndexRouteImport } from './routes/dashboard/inbox/index'
import { Route as DashboardInboxIdRouteRouteImport } from './routes/dashboard/inbox/$id/route'
import { Route as DashboardSettingsIndexRouteImport } from './routes/dashboard/settings/index'
import { Route as DashboardSuppressionsIndexRouteImport } from './routes/dashboard/suppressions/index'
import { Route as DashboardWebhooksIndexRouteImport } from './routes/dashboard/webhooks/index'
import { Route as LoginCompleteIndexRouteImport } from './routes/login/complete/index'
import { Route as LoginSsoCallbackIndexRouteImport } from './routes/login/sso-callback/index'
import { Route as ContentAudienceSlugIndexRouteImport } from './routes/_content/audience/$slug/index'
import { Route as ContentBlogSlugIndexRouteImport } from './routes/_content/blog/$slug/index'
import { Route as ContentCompareSlugIndexRouteImport } from './routes/_content/compare/$slug/index'
import { Route as ContentDocsAgentOnboardingIndexRouteImport } from './routes/_content/docs/agent-onboarding/index'
import { Route as ContentDocsApiIndexRouteImport } from './routes/_content/docs/api/index'
import { Route as ContentDocsAuthenticationIndexRouteImport } from './routes/_content/docs/authentication/index'
import { Route as ContentDocsChangelogIndexRouteImport } from './routes/_content/docs/changelog/index'
import { Route as ContentDocsDomainsIndexRouteImport } from './routes/_content/docs/domains/index'
import { Route as ContentDocsErrorsIndexRouteImport } from './routes/_content/docs/errors/index'
import { Route as ContentDocsInboundIndexRouteImport } from './routes/_content/docs/inbound/index'
import { Route as ContentDocsMcpIndexRouteImport } from './routes/_content/docs/mcp/index'
import { Route as ContentDocsQuickstartIndexRouteImport } from './routes/_content/docs/quickstart/index'
import { Route as ContentDocsSdksIndexRouteImport } from './routes/_content/docs/sdks/index'
import { Route as ContentDocsWebhooksIndexRouteImport } from './routes/_content/docs/webhooks/index'
import { Route as ContentFeatureSlugIndexRouteImport } from './routes/_content/feature/$slug/index'
import { Route as ContentDocsApiReferenceIndexRouteImport } from './routes/_content/docs/api/reference/index'
import { Route as ContentDocsIntegrationsAiFrameworksIndexRouteImport } from './routes/_content/docs/integrations/ai-frameworks/index'
import { Route as DashboardIdentitiesAliasesNewIndexRouteImport } from './routes/dashboard/identities/aliases/new/index'
import { Route as DashboardIdentitiesDomainsNewIndexRouteImport } from './routes/dashboard/identities/domains/new/index'
import { Route as DashboardInboxIdForwardIndexRouteImport } from './routes/dashboard/inbox/$id/forward/index'
import { Route as DashboardInboxIdReplyIndexRouteImport } from './routes/dashboard/inbox/$id/reply/index'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ContentRouteRoute = ContentRouteRouteImport.update({
            id: '/_content',getParentRoute: () => rootRouteImport
          })
const DashboardRouteRoute = DashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const ContentAudienceRouteRoute = ContentAudienceRouteRouteImport.update({
            id: '/audience',path: '/audience',getParentRoute: () => ContentRouteRoute
          })
const ContentBlogRouteRoute = ContentBlogRouteRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => ContentRouteRoute
          })
const ContentCompareRouteRoute = ContentCompareRouteRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => ContentRouteRoute
          })
const ContentDocsRouteRoute = ContentDocsRouteRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => ContentRouteRoute
          })
const ContentFeatureRouteRoute = ContentFeatureRouteRouteImport.update({
            id: '/feature',path: '/feature',getParentRoute: () => ContentRouteRoute
          })
const ContentPricingRouteRoute = ContentPricingRouteRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => ContentRouteRoute
          })
const ClaimIndexRoute = ClaimIndexRouteImport.update({
            id: '/claim/',path: '/claim/',getParentRoute: () => rootRouteImport
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardIdentitiesRouteRoute = DashboardIdentitiesRouteRouteImport.update({
            id: '/identities',path: '/identities',getParentRoute: () => DashboardRouteRoute
          })
const DashboardInboxRouteRoute = DashboardInboxRouteRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => DashboardRouteRoute
          })
const LoginIndexRoute = LoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => rootRouteImport
          })
const PrivacyIndexRoute = PrivacyIndexRouteImport.update({
            id: '/privacy/',path: '/privacy/',getParentRoute: () => rootRouteImport
          })
const TermsIndexRoute = TermsIndexRouteImport.update({
            id: '/terms/',path: '/terms/',getParentRoute: () => rootRouteImport
          })
const ContentAudienceIndexRoute = ContentAudienceIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ContentAudienceRouteRoute
          })
const ContentBlogIndexRoute = ContentBlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ContentBlogRouteRoute
          })
const ContentCompareIndexRoute = ContentCompareIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ContentCompareRouteRoute
          })
const ContentDocsIndexRoute = ContentDocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentFeatureIndexRoute = ContentFeatureIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ContentFeatureRouteRoute
          })
const ContentPricingIndexRoute = ContentPricingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ContentPricingRouteRoute
          })
const DashboardAnalyticsIndexRoute = DashboardAnalyticsIndexRouteImport.update({
            id: '/analytics/',path: '/analytics/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardApiKeysIndexRoute = DashboardApiKeysIndexRouteImport.update({
            id: '/api-keys/',path: '/api-keys/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardComposeIndexRoute = DashboardComposeIndexRouteImport.update({
            id: '/compose/',path: '/compose/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardConnectedAccountsIndexRoute = DashboardConnectedAccountsIndexRouteImport.update({
            id: '/connected-accounts/',path: '/connected-accounts/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardContactsIndexRoute = DashboardContactsIndexRouteImport.update({
            id: '/contacts/',path: '/contacts/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardIdentitiesIndexRoute = DashboardIdentitiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardIdentitiesRouteRoute
          })
const DashboardInboxIndexRoute = DashboardInboxIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardInboxRouteRoute
          })
const DashboardInboxIdRouteRoute = DashboardInboxIdRouteRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => DashboardInboxRouteRoute
          })
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardSuppressionsIndexRoute = DashboardSuppressionsIndexRouteImport.update({
            id: '/suppressions/',path: '/suppressions/',getParentRoute: () => DashboardRouteRoute
          })
const DashboardWebhooksIndexRoute = DashboardWebhooksIndexRouteImport.update({
            id: '/webhooks/',path: '/webhooks/',getParentRoute: () => DashboardRouteRoute
          })
const LoginCompleteIndexRoute = LoginCompleteIndexRouteImport.update({
            id: '/login/complete/',path: '/login/complete/',getParentRoute: () => rootRouteImport
          })
const LoginSsoCallbackIndexRoute = LoginSsoCallbackIndexRouteImport.update({
            id: '/login/sso-callback/',path: '/login/sso-callback/',getParentRoute: () => rootRouteImport
          })
const ContentAudienceSlugIndexRoute = ContentAudienceSlugIndexRouteImport.update({
            id: '/$slug/',path: '/$slug/',getParentRoute: () => ContentAudienceRouteRoute
          })
const ContentBlogSlugIndexRoute = ContentBlogSlugIndexRouteImport.update({
            id: '/$slug/',path: '/$slug/',getParentRoute: () => ContentBlogRouteRoute
          })
const ContentCompareSlugIndexRoute = ContentCompareSlugIndexRouteImport.update({
            id: '/$slug/',path: '/$slug/',getParentRoute: () => ContentCompareRouteRoute
          })
const ContentDocsAgentOnboardingIndexRoute = ContentDocsAgentOnboardingIndexRouteImport.update({
            id: '/agent-onboarding/',path: '/agent-onboarding/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsApiIndexRoute = ContentDocsApiIndexRouteImport.update({
            id: '/api/',path: '/api/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsAuthenticationIndexRoute = ContentDocsAuthenticationIndexRouteImport.update({
            id: '/authentication/',path: '/authentication/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsChangelogIndexRoute = ContentDocsChangelogIndexRouteImport.update({
            id: '/changelog/',path: '/changelog/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsDomainsIndexRoute = ContentDocsDomainsIndexRouteImport.update({
            id: '/domains/',path: '/domains/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsErrorsIndexRoute = ContentDocsErrorsIndexRouteImport.update({
            id: '/errors/',path: '/errors/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsInboundIndexRoute = ContentDocsInboundIndexRouteImport.update({
            id: '/inbound/',path: '/inbound/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsMcpIndexRoute = ContentDocsMcpIndexRouteImport.update({
            id: '/mcp/',path: '/mcp/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsQuickstartIndexRoute = ContentDocsQuickstartIndexRouteImport.update({
            id: '/quickstart/',path: '/quickstart/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsSdksIndexRoute = ContentDocsSdksIndexRouteImport.update({
            id: '/sdks/',path: '/sdks/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsWebhooksIndexRoute = ContentDocsWebhooksIndexRouteImport.update({
            id: '/webhooks/',path: '/webhooks/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentFeatureSlugIndexRoute = ContentFeatureSlugIndexRouteImport.update({
            id: '/$slug/',path: '/$slug/',getParentRoute: () => ContentFeatureRouteRoute
          })
const ContentDocsApiReferenceIndexRoute = ContentDocsApiReferenceIndexRouteImport.update({
            id: '/api/reference/',path: '/api/reference/',getParentRoute: () => ContentDocsRouteRoute
          })
const ContentDocsIntegrationsAiFrameworksIndexRoute = ContentDocsIntegrationsAiFrameworksIndexRouteImport.update({
            id: '/integrations/ai-frameworks/',path: '/integrations/ai-frameworks/',getParentRoute: () => ContentDocsRouteRoute
          })
const DashboardIdentitiesAliasesNewIndexRoute = DashboardIdentitiesAliasesNewIndexRouteImport.update({
            id: '/aliases/new/',path: '/aliases/new/',getParentRoute: () => DashboardIdentitiesRouteRoute
          })
const DashboardIdentitiesDomainsNewIndexRoute = DashboardIdentitiesDomainsNewIndexRouteImport.update({
            id: '/domains/new/',path: '/domains/new/',getParentRoute: () => DashboardIdentitiesRouteRoute
          })
const DashboardInboxIdForwardIndexRoute = DashboardInboxIdForwardIndexRouteImport.update({
            id: '/forward/',path: '/forward/',getParentRoute: () => DashboardInboxIdRouteRoute
          })
const DashboardInboxIdReplyIndexRoute = DashboardInboxIdReplyIndexRouteImport.update({
            id: '/reply/',path: '/reply/',getParentRoute: () => DashboardInboxIdRouteRoute
          })





const ContentAudienceRouteRouteChildren = {
  ContentAudienceIndexRoute: ContentAudienceIndexRoute,ContentAudienceSlugIndexRoute: ContentAudienceSlugIndexRoute
}

const ContentAudienceRouteRouteWithChildren = ContentAudienceRouteRoute._addFileChildren(ContentAudienceRouteRouteChildren)




const ContentBlogRouteRouteChildren = {
  ContentBlogIndexRoute: ContentBlogIndexRoute,ContentBlogSlugIndexRoute: ContentBlogSlugIndexRoute
}

const ContentBlogRouteRouteWithChildren = ContentBlogRouteRoute._addFileChildren(ContentBlogRouteRouteChildren)




const ContentCompareRouteRouteChildren = {
  ContentCompareIndexRoute: ContentCompareIndexRoute,ContentCompareSlugIndexRoute: ContentCompareSlugIndexRoute
}

const ContentCompareRouteRouteWithChildren = ContentCompareRouteRoute._addFileChildren(ContentCompareRouteRouteChildren)




const ContentDocsRouteRouteChildren = {
  ContentDocsIndexRoute: ContentDocsIndexRoute,ContentDocsAgentOnboardingIndexRoute: ContentDocsAgentOnboardingIndexRoute,ContentDocsApiIndexRoute: ContentDocsApiIndexRoute,ContentDocsAuthenticationIndexRoute: ContentDocsAuthenticationIndexRoute,ContentDocsChangelogIndexRoute: ContentDocsChangelogIndexRoute,ContentDocsDomainsIndexRoute: ContentDocsDomainsIndexRoute,ContentDocsErrorsIndexRoute: ContentDocsErrorsIndexRoute,ContentDocsInboundIndexRoute: ContentDocsInboundIndexRoute,ContentDocsMcpIndexRoute: ContentDocsMcpIndexRoute,ContentDocsQuickstartIndexRoute: ContentDocsQuickstartIndexRoute,ContentDocsSdksIndexRoute: ContentDocsSdksIndexRoute,ContentDocsWebhooksIndexRoute: ContentDocsWebhooksIndexRoute,ContentDocsApiReferenceIndexRoute: ContentDocsApiReferenceIndexRoute,ContentDocsIntegrationsAiFrameworksIndexRoute: ContentDocsIntegrationsAiFrameworksIndexRoute
}

const ContentDocsRouteRouteWithChildren = ContentDocsRouteRoute._addFileChildren(ContentDocsRouteRouteChildren)




const ContentFeatureRouteRouteChildren = {
  ContentFeatureIndexRoute: ContentFeatureIndexRoute,ContentFeatureSlugIndexRoute: ContentFeatureSlugIndexRoute
}

const ContentFeatureRouteRouteWithChildren = ContentFeatureRouteRoute._addFileChildren(ContentFeatureRouteRouteChildren)




const ContentPricingRouteRouteChildren = {
  ContentPricingIndexRoute: ContentPricingIndexRoute
}

const ContentPricingRouteRouteWithChildren = ContentPricingRouteRoute._addFileChildren(ContentPricingRouteRouteChildren)



const ContentRouteRouteChildren = {
  ContentAudienceRouteRoute: ContentAudienceRouteRouteWithChildren,ContentBlogRouteRoute: ContentBlogRouteRouteWithChildren,ContentCompareRouteRoute: ContentCompareRouteRouteWithChildren,ContentDocsRouteRoute: ContentDocsRouteRouteWithChildren,ContentFeatureRouteRoute: ContentFeatureRouteRouteWithChildren,ContentPricingRouteRoute: ContentPricingRouteRouteWithChildren
}

const ContentRouteRouteWithChildren = ContentRouteRoute._addFileChildren(ContentRouteRouteChildren)




const DashboardIdentitiesRouteRouteChildren = {
  DashboardIdentitiesIndexRoute: DashboardIdentitiesIndexRoute,DashboardIdentitiesAliasesNewIndexRoute: DashboardIdentitiesAliasesNewIndexRoute,DashboardIdentitiesDomainsNewIndexRoute: DashboardIdentitiesDomainsNewIndexRoute
}

const DashboardIdentitiesRouteRouteWithChildren = DashboardIdentitiesRouteRoute._addFileChildren(DashboardIdentitiesRouteRouteChildren)




const DashboardInboxIdRouteRouteChildren = {
  DashboardInboxIdForwardIndexRoute: DashboardInboxIdForwardIndexRoute,DashboardInboxIdReplyIndexRoute: DashboardInboxIdReplyIndexRoute
}

const DashboardInboxIdRouteRouteWithChildren = DashboardInboxIdRouteRoute._addFileChildren(DashboardInboxIdRouteRouteChildren)



const DashboardInboxRouteRouteChildren = {
  DashboardInboxIdRouteRoute: DashboardInboxIdRouteRouteWithChildren,DashboardInboxIndexRoute: DashboardInboxIndexRoute
}

const DashboardInboxRouteRouteWithChildren = DashboardInboxRouteRoute._addFileChildren(DashboardInboxRouteRouteChildren)



const DashboardRouteRouteChildren = {
  DashboardIdentitiesRouteRoute: DashboardIdentitiesRouteRouteWithChildren,DashboardInboxRouteRoute: DashboardInboxRouteRouteWithChildren,DashboardIndexRoute: DashboardIndexRoute,DashboardAnalyticsIndexRoute: DashboardAnalyticsIndexRoute,DashboardApiKeysIndexRoute: DashboardApiKeysIndexRoute,DashboardComposeIndexRoute: DashboardComposeIndexRoute,DashboardConnectedAccountsIndexRoute: DashboardConnectedAccountsIndexRoute,DashboardContactsIndexRoute: DashboardContactsIndexRoute,DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,DashboardSuppressionsIndexRoute: DashboardSuppressionsIndexRoute,DashboardWebhooksIndexRoute: DashboardWebhooksIndexRoute
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(DashboardRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ContentRouteRoute: ContentRouteRouteWithChildren,DashboardRouteRoute: DashboardRouteRouteWithChildren,ClaimIndexRoute: ClaimIndexRoute,LoginIndexRoute: LoginIndexRoute,PrivacyIndexRoute: PrivacyIndexRoute,TermsIndexRoute: TermsIndexRoute,LoginCompleteIndexRoute: LoginCompleteIndexRoute,LoginSsoCallbackIndexRoute: LoginSsoCallbackIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)